import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import DataTable from "../../../components/AdminTable//DataTable"


function IngredientAlert() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },
    {
      header: "	Ingredient(Code)",
      accessorKey: "IngredientCode",
    },
    {
      header: "Category",
      accessorKey: "Category",
    },
    {
      header: "	Stock Qty/Amount",
      accessorKey: "StockQtyAmount",
    },
    {
      header: "Alert Qty/Amount",
      accessorKey: "AlertQtyAmount",
    },

  ]);
  const [data] = useState([
    {
      SN: 1,
      IngredientCode: "box basbousa Large(006)	",
      Category: "بوكس بسبوسة كبير	",
      StockQtyAmount: "153",
      AlertQtyAmount: "10.00",

    },

  ]);


  const navigate = useNavigate();
  return (
    <main>

      <div className="text-[#7B20C7] text-3xl text-center mb-4">Alert Inventory</div><span className="w-full bg-[#7B20C7] h-1 my-2 inline-block"></span>

      <button
        className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
        type="button"
        onClick={() => navigate(-1)}
      >
        Back
      </button>


      <DataTable
        columns={columns}
        data={data}
      />

    </main>
  );
}

export default IngredientAlert;
